import { render, staticRenderFns } from "./btnAddReportCardStepPage.vue?vue&type=template&id=70e0b1ab"
import script from "./btnAddReportCardStepPage.vue?vue&type=script&lang=js"
export * from "./btnAddReportCardStepPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports